export const getWellLoggingKeysAndCurvesFromWellProfile = (researches, stateWell) => {
    /*
        В данных id представлено разными полями: param and curve
    */
    let wellLoggingIds = [];
    const wellLoggingKeys = [];
    let curveSettings = {};
    let curveDisplaySettings = {};

    const params = stateWell.params.find(p => p.paramColumn === 7);

    if (params?.children) {
        wellLoggingIds = params.children.map(({ param }) => param);
    }

    researches.forEach(r1 => {
        r1.children.forEach(r2 => {
            r2.children.forEach(research => {
                if (wellLoggingIds.includes(research.curve)) {
                    wellLoggingKeys.push(research.key);
                    if (params.children.some(child => child.param === research.curve && child.curveSettings)) {
                        curveSettings = {
                            ...curveSettings,
                            [research.key]: params.children.filter(child => child.param === research.curve)[0]
                                .curveSettings,
                        };
                        curveDisplaySettings = {
                            ...curveDisplaySettings,
                            [research.key]: params.children.filter(child => child.param === research.curve)[0]
                                .curveDisplaySettings,
                        };
                    }
                }
            });
        });
    });

    return {
        wellLoggingKeys: wellLoggingKeys,
        curveSettings: curveSettings,
        curveDisplaySettings: curveDisplaySettings,
    };
};

const isOrderHigh = (currentType, type, typesOrder) => {
    if (!currentType) {
        return true;
    }
    const orderOfCurrentType = typesOrder.findIndex(t => t === currentType);
    const typeOrder = typesOrder.findIndex(t => t === type);
    return typeOrder < orderOfCurrentType;
};

const searchByOrder = (typesOrder, researches) => {
    let res = null;
    researches.forEach(r1 => {
        r1.children.forEach(r2 => {
            r2.children.forEach(research => {
                if (
                    typesOrder.includes(research.type) &&
                    research.isSelected &&
                    isOrderHigh(res && res.type, research.type, typesOrder)
                ) {
                    res = research;
                }
            });
        });
    });

    return res;
};

const getSettingForResearch = (research, settings) => ({
    ...settings,
    code: research.code,
    key: research.code,
    title: research.type,
});

export const getWellLoggingKeyForTemplate = (researches, stateWell, researchOrder) => {
    /*
        В данных id представлено разными полями: param and curve
    */
    let wellLoggingTypes = new Set([]);
    const wellLoggingKeys = [];
    const curveSettings = {};
    let curveDisplaySettings = {};
    const params = stateWell.params.find(p => p.paramColumn === 7);
    const typeSettings = {};

    if (params?.children) {
        for (const { strParamValue, curveSettings } of params.children) {
            if (curveSettings) {
                typeSettings[strParamValue] = curveSettings;
            }
            wellLoggingTypes.add(strParamValue);
        }
    }

    wellLoggingTypes = Array.from(wellLoggingTypes);

    researches.forEach(r1 => {
        r1.children.forEach(r2 => {
            r2.children.forEach(research => {
                if (wellLoggingTypes.includes(research.type) && research.isSelected) {
                    wellLoggingTypes = wellLoggingTypes.filter(type => type !== research.type);

                    if (typeSettings[research.type]) {
                        curveSettings[research.key] = typeSettings[research.type];
                    }
                    wellLoggingKeys.push(research.key);

                    if (params.children.some(child => child.param === research.curve && child.curveSettings)) {
                        curveDisplaySettings = {
                            ...curveDisplaySettings,
                            [research.key]: params.children.filter(child => child.param === research.curve)[0]
                                .curveDisplaySettings,
                        };
                    }
                }
            });
        });
    });

    if (researchOrder) {
        for (const type of wellLoggingTypes) {
            const typeOrder = researchOrder[type];
            if (!typeOrder) {
                continue;
            }
            const foundedResearch = searchByOrder(typeOrder, researches);
            for (const oType of typeOrder) {
                typeSettings[oType] = { ...typeSettings[type], title: oType };
            }
            if (foundedResearch) {
                const { key: foundedKey } = foundedResearch;
                if (typeSettings[type]) {
                    curveSettings[foundedKey] = getSettingForResearch(foundedResearch, typeSettings[type]);
                }
                wellLoggingKeys.push(foundedKey);
            }
        }
    }

    return {
        wellLoggingKeys: wellLoggingKeys,
        curveSettings: curveSettings,
        curveDisplaySettings: curveDisplaySettings,
        typeSettings,
    };
};
